import { Heart, Target, Book } from 'lucide-react';
import { churchInfo, aboutContent } from '../mock';
import { Card, CardContent } from '../components/ui/card';

export const About = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-blue-800" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-7xl md:text-8xl font-bold text-white mb-4">About Us</h1>
          <p className="text-2xl text-yellow-300">{churchInfo.tagline}</p>
        </div>
      </section>

      {/* Mission, Vision, History */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <Card className="border-2 border-yellow-400 hover:border-yellow-500 transition-colors duration-200 hover:shadow-xl">
              <CardContent className="p-8">
                <div className="bg-blue-100 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
                  <Heart className="h-8 w-8 text-blue-600" />
                </div>
                <h2 className="text-4xl font-bold text-blue-800 mb-4">Our Mission</h2>
                <p className="text-blue-700 leading-relaxed">{aboutContent.mission}</p>
              </CardContent>
            </Card>

            <Card className="border-2 border-yellow-400 hover:border-yellow-500 transition-colors duration-200 hover:shadow-xl">
              <CardContent className="p-8">
                <div className="bg-blue-100 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
                  <Target className="h-8 w-8 text-blue-600" />
                </div>
                <h2 className="text-4xl font-bold text-blue-800 mb-4">Our Vision</h2>
                <p className="text-blue-700 leading-relaxed">{aboutContent.vision}</p>
              </CardContent>
            </Card>

            <Card className="border-2 border-yellow-400 hover:border-yellow-500 transition-colors duration-200 hover:shadow-xl">
              <CardContent className="p-8">
                <div className="bg-blue-100 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
                  <Book className="h-8 w-8 text-blue-600" />
                </div>
                <h2 className="text-4xl font-bold text-blue-800 mb-4">Our History</h2>
                <p className="text-blue-700 leading-relaxed">{aboutContent.history}</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Pastor Section */}
      <section className="py-16 bg-gradient-to-br from-yellow-50 to-blue-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-6xl md:text-7xl font-bold text-blue-800 mb-4">Our Shepherd</h2>
            <p className="text-xl text-blue-700">Led by faithful spiritual leadership</p>
          </div>
          <Card className="border-4 border-yellow-400 shadow-2xl">
            <CardContent className="p-8 md:p-12">
              <div className="text-center">
                <div className="mb-6">
                  <img
                    src="/images/pastor.jpg"
                    alt="Pastor Carlous Parker"
                    className="w-64 h-64 rounded-full mx-auto object-cover border-8 border-yellow-400 shadow-2xl"
                  />
                </div>
                <h3 className="text-5xl font-bold text-blue-800 mb-2">{churchInfo.pastor}</h3>
                <p className="text-2xl text-yellow-600 mb-6 font-semibold">Senior Pastor</p>
                <p className="text-lg text-blue-700 leading-relaxed max-w-2xl mx-auto">
                  Pastor Parker leads our congregation with wisdom, compassion, and a deep commitment to God&apos;s Word. 
                  His ministry focuses on building a strong church family rooted in biblical truth and brotherly love, 
                  while reaching out to our community with the transformative message of Jesus Christ.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Location */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-6xl md:text-7xl font-bold text-blue-800 mb-4">Visit Us</h2>
            <p className="text-xl text-blue-700">We look forward to welcoming you</p>
          </div>
          <div className="bg-gradient-to-br from-blue-50 to-yellow-50 rounded-2xl p-8 md:p-12 text-center border-4 border-blue-300 shadow-xl">
            <div className="max-w-2xl mx-auto">
              <h3 className="text-4xl font-bold text-blue-800 mb-4">{churchInfo.name}</h3>
              <p className="text-xl text-blue-700 mb-8 leading-relaxed">
                {aboutContent.visitMessage}
              </p>
              <a
                href={`https://maps.google.com/?q=${encodeURIComponent('Main Street and 119th Street, Los Angeles, CA 90061')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 transition-all duration-200 hover:shadow-lg transform hover:-translate-y-0.5 text-lg"
              >
                Get Directions
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
